import { render, staticRenderFns } from "./BannerTable.vue?vue&type=template&id=a0107f08&scoped=true&"
import script from "./BannerTable.vue?vue&type=script&lang=ts&"
export * from "./BannerTable.vue?vue&type=script&lang=ts&"
import style0 from "./BannerTable.vue?vue&type=style&index=0&id=a0107f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0107f08",
  null
  
)

export default component.exports